/**
 * List of page names used in the portal application.
 *
 * If new pages or components are added to Portal,
 * they must be included in this array and to be used
 * on the PORTAL.PageNameClientLanguage table.
 *
 *
 */
export const PORTAL_PAGE_NAMES = [
	'401',
	'403',
	'404',
	'500',
	'about',
	'account',
	'account-selector',
	'accountInformation',
	'changeaddress',
	'changepassword',
	'document',
	'e-notices',
	'enrollment',
	'error-handler',
	'faq',
	'file-a-complaint',
	'forget-password-reset',
	'forgot-password',
	'reset-password',
	'header-account-menu',
	'help',
	'history',
	'home',
	'intro',
	'login',
	'maintenance',
	'make-a-payment',
	'more',
	'notificationPreferences',
	'payment',
	'premium-payments',
	'provider-search',
	'recurring-payment',
	'register',
	'retrieve-username',
	'secure-messaging',
	'settings',
	'sitemap',
	'toastService',
	'tutorial',
	'confirm-account',
	'external-link-confirmation'
] as const;

export type PortalPageName = (typeof PORTAL_PAGE_NAMES)[number];
